import { useState, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'redux/use-hooks';
import {
  selectStatusGlobalAlert,
  selectStatusActionStatus,
  actions as statusSliceActions
} from 'redux/slices/status';
const { clearGlobalAlert } = statusSliceActions;
// @ts-ignore
import IconCheckCircleImage from 'assets/images/icon-check-circle.svg';
// @ts-ignore
import IconsAlertCircleImage from 'assets/images/icon_alert-circle.svg';
import CloseBigIcon from 'components/icons/CloseBigIcon';

import {
  StyledAlertContainer,
  StyledMessageCode,
  StyledAlert,
  StyledContent,
  StyledIcon,
  StyledText,
  StyledClose,
  StyledHeader,
  StyledConsole
} from './global-alert.style';

const GlobalAlert = ({ closeIcon = true }) => {
  const [closing, setClosing] = useState<string>('');
  const [alerts, setAlerts] = useState([]);

  const dispatch = useAppDispatch();
  const globalAlert = useAppSelector(selectStatusGlobalAlert);
  const actionStatus = useAppSelector(selectStatusActionStatus);

  const handleClose = (type) => {
    setClosing(type);
    setTimeout(() => {
      dispatch(clearGlobalAlert(type));
      setClosing('');
    }, 300);
  };

  useEffect(() => {
    setAlerts(
      Object.keys(globalAlert)
        .filter((type) => globalAlert[type])
        .map((type) => ({
          type,
          ...globalAlert[type],
          ...actionStatus[type]
        }))
    );
  }, [globalAlert]);

  if (!alerts.length) return null;

  return (
    <StyledAlertContainer>
      {alerts
        .filter((alert) => alert.show)
        .map((alert, i) => {
          const msgCode =
            typeof alert.messageCode === 'string' ? alert.messageCode : '';

          return (
            <StyledAlert
              key={`alert-${i}`}
              success={alert.success}
              closing={closing}
              className={`number-${alert.type}`}
            >
              <StyledContent>
                <StyledIcon>
                  <img
                    src={
                      alert.success
                        ? IconCheckCircleImage
                        : IconsAlertCircleImage
                    }
                    alt={alert.type}
                  />
                  <StyledHeader success={alert.success}>
                    {alert.success ? 'success' : 'error'}
                  </StyledHeader>
                </StyledIcon>
                <StyledText>
                  <StyledMessageCode>
                    {msgCode
                      ? msgCode
                      : 'Sorry an error has occurred. You may want to try again.'}
                  </StyledMessageCode>
                  {alert.console && (
                    <StyledConsole>{alert.errorMessage}</StyledConsole>
                  )}
                </StyledText>
                {closeIcon && (
                  <StyledClose onClick={() => handleClose(alert.type)}>
                    <CloseBigIcon color="#3f3f3f" />
                  </StyledClose>
                )}
              </StyledContent>
            </StyledAlert>
          );
        })}
    </StyledAlertContainer>
  );
};

export default GlobalAlert;
